import { Components, Theme } from '@mui/material'
import { primaryContainedButtonStyle, secondaryContainedButtonStyle } from './MuiButton'

export const MuiFab: Components<Omit<Theme, 'components'>>['MuiFab'] = {
  defaultProps: {
    size: 'medium',
  },
  styleOverrides: {
    root: {
      '&.Mui-disabled': {
        opacity: 0.4,
      },
    },
  },
  variants: [
    {
      props: { color: 'primary' },
      style: ({ theme }) => primaryContainedButtonStyle(theme),
    },
    {
      props: { color: 'secondary' },
      style: ({ theme }) => secondaryContainedButtonStyle(theme),
    },
  ],
}
